import { useCallback } from 'react';

import { useDeleteStream } from '@vlabs/api/artemy/client';
import type { StreamId } from '@vlabs/api/artemy/model';

interface UseDeleteSourceStreamOptions {
  streamId: StreamId;
  onDeleted?: VoidFunction;
}

// Удаление источника со страницы настроек: подтверждение + DELETE + переход.
function useDeleteSourceStream({
  streamId,
  onDeleted = undefined,
}: UseDeleteSourceStreamOptions): { onDelete: VoidFunction; isDeleting: boolean } {
  const deleteStream = useDeleteStream({
    mutation: {
      onSuccess: onDeleted,
    },
  });

  const onDelete = useCallback(() => {
    deleteStream.mutate({ streamId });
  }, [deleteStream, streamId]);

  return { onDelete, isDeleting: deleteStream.isPending };
}

export { useDeleteSourceStream };
